import { Create, NumberInput, SelectInput, SimpleForm, TextInput, useNotify } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { jsonFormat, jsonParseArray, jsonParseObject, recurrencePeriodChoices, scheduleTypeChoices } from './constants';

const ScheduleTemplatesCreate = () => {
  const navigate = useNavigate();
  const notify = useNotify();
  return (
    <Create
      mutationOptions={{
        onSuccess: () => {
          notify('Created');
          navigate(-1);
        }
      }}
    >
      <SimpleForm defaultValues={{ options: {}, scheduleDays: [], totalDuration: 0 }}>
        <TextInput source="country" label="Country (2-char ISO, empty = global)" inputProps={{ maxLength: 2 }} />
        <TextInput source="name" label="Name" required />
        <TextInput source="description" label="Description" fullWidth />
        <SelectInput source="scheduleType" label="Schedule type" choices={scheduleTypeChoices} required />
        <SelectInput source="recurrencePeriod" label="Recurrence period" choices={recurrencePeriodChoices} />
        <NumberInput source="totalDuration" label="Total duration" />
        <TextInput source="options" label="Options (JSON)" multiline fullWidth minRows={8} format={jsonFormat} parse={jsonParseObject} />
        <TextInput source="scheduleDays" label="Schedule days (JSON array)" multiline fullWidth minRows={8} format={jsonFormat} parse={jsonParseArray} />
      </SimpleForm>
    </Create>
  );
};

export default ScheduleTemplatesCreate;
